module.exports = __webpack_public_path__ + "static/media/fracture-placa.81126f97.png";